import { analyticsEvent } from "@up/analytics";
import { useTheme } from "@up/data";
import { Toast, UPLink } from "@up/ui";

export const ViewSyllabi = ({ close }: { close: () => void }) => {
  const theme = useTheme();

  return (
    <div className="flex flex-col gap-4">
      <div className="pt-4">
        <Toast variant="success">
          Thanks you for your interest. We'll be in touch.
        </Toast>
      </div>
      <UPLink
        className={theme.buttonPrimaryClass}
        href="/syllabus"
        onClick={() => {
          analyticsEvent({
            event: "downloadSleekNote",
          });
          close();
        }}
      >
        View Syllabi
      </UPLink>
    </div>
  );
};
